






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IProject, IPageParams, IDepartment } from '../../models';
import paginationMixin from '@/mixins/pagintation';
const ns = { namespace: 'position' };

@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'position',
  }),
  mixins: [paginationMixin],
})
export default class PositionList extends Vue {
  @Action('getEntities', ns) getEntities: () => void;
  @Getter('entitiesSlice', ns)
  entitiesSlice: IProject[];
  @State('pageParams', ns) pageParams: IPageParams;
  selected = [];
  interval = null;
  headers = [
    { text: 'Название', value: 'name' },
    { text: 'Отдел', value: 'department.name' },
  ];
  created() {
    this.getEntities();
  }
}
